import React, { useContext, useEffect, useState } from "react";
import "../../css/campaign.css";
import { Badge, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, ToggleButton, useMediaQuery, useTheme } from "@mui/material";
import { cancelCampaign, changeECApplicantViewAccess, closeCampaign, discardCampiagn, updateCampaignViewCount, updateCampaignsStatus } from "./campaign-repository";
import InstagramIcon from '@mui/icons-material/Instagram';
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import { getCampaign, handleApplyCampaign } from "./campaign-repository";
import { UserDetailsContext } from "../context/user-details-context";
import MailIcon from '@mui/icons-material/Mail';
import DialogBox from "../common/dialog-box";
import CustomAlert from "../common/alert";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import dayjs from 'dayjs';

function CampaignDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = window.location.pathname;
    const pathSegments = pathname.split('/');
    const startPath = '/' + pathSegments[1];
    const { loggedUser } = useContext(UserDetailsContext);
    const [campaign, setCampaign] = useState();
    const [openInstaHandleAlert, setOpenInstaHandleAlert] = useState(false);
    const [apply, setApply] = useState('');
    const [campaignid] = useState(location.state.campaignid);
    const [openClosedCampaign, setOpenClosedCampaign] = useState(false);
    const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [invoiceField, setInvoiceField] = useState({
        invoiceNumber: "", paymentId: ""
    });
    const [openConfirm, setOpenConfirm] = useState(false);
    const [ecApplicantViewAccess, setEcApplicantViewAccess] = useState();
    const [campaignManager, setCampaignManager] = useState([
        { name: '', email: '', phoneNumber: '' },
        { name: '', email: '', phoneNumber: '' }
    ]);

    useEffect(() => {
        getCampaign(campaignid, setCampaign);
        if (loggedUser && loggedUser.role === "CREATOR") {
            updateCampaignViewCount(campaignid);
        }
    }, [apply, campaignid, loggedUser]);

    const handleEditCampaign = (campaignStatus) => {
        const pathSegments = pathname.split('/');
        const startPath = '/' + pathSegments[1];
        navigate(`${startPath}/create`, { state: { campaign, status: campaignStatus, fromPage: 'details' } });
    };

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');
    const [openWithdrawConfirmationDialog, setOpenWithdrawConfirmationDialog] = useState(false);

    // const handleRaiseInvoice = (campaignName) => {
    //     const pathSegments = pathname.split('/');
    //     const startPath = '/' + pathSegments[1];
    //     const invoiceId = campaign.invoiceId;
    //     if (invoiceId) {
    //         navigate(`${startPath}/invoice/${invoiceId}`, { state: { campaign, fromPage: 'details' } });
    //     } else {
    //         navigate(`${startPath}/invoice/create-invoice`, { state: { campaign, fromPage: 'details' } });
    //     }
    // };

    const openDialogForCloseCampaign = () => {
        setOpenClosedCampaign(!openClosedCampaign);
    }

    const closedCampaignAction = () => {
        if (campaign.status === 'Live' || (campaign.status === 'Completed' && !campaign.campaignClosed)) {
            closeCampaign((campaign && campaign.campaignId), campaign.status, navigate);
        } else if (campaign.status === 'Draft') {
            discardCampiagn((campaign && campaign.campaignId), navigate);
        } else if (campaign.status === 'Pending') {
            cancelCampaign((campaign && campaign.campaignId), campaign.status, navigate);
        }
    }

    const handleCampaignApplication = () => {
        const pathSegments = pathname.split('/');
        const startPath = '/' + pathSegments[1];
        const productionStart = dayjs(campaign.campaignStartDate).add(5, 'day');
        const productionEnd = dayjs(campaign.campaignStartDate).add(35, 'day');
        navigate(`${startPath}/applications`, { state: { campaignId: campaign.campaignId, campaignName: campaign.campaignName, noOfCreators: campaign.creators, page: 'details', productionStartDate: productionStart.toISOString(), productionEndDate: productionEnd.toISOString(), campaignClosed: campaign.campaignClosed } });
    }

    const handleInvoiceDialogOpen = () => {
        setOpenInvoiceDialog(true);
    };

    const handleInvoiceDialogClose = () => {
        setOpenInvoiceDialog(false);
    };

    const handleInvoiceChange = (fieldName, value) => {
        setInvoiceField((invoiceField) => {
            return {
                ...invoiceField,
                [fieldName]: value
            };
        });
    }

    const handleEcAccessToggleClick = (value) => {
        setEcApplicantViewAccess(value);
        setOpenConfirm(true);
    };

    const handleEcAccessConfirm = async () => {
        setOpenConfirm(false);
        changeECApplicantViewAccess(campaignid, !ecApplicantViewAccess, setApply);
    };

    const handleEcAccessCancel = () => {
        setOpenConfirm(false);
    }

    const handleManagerChange = (index, field, value) => {
        setCampaignManager(prev => prev.map((m, i) => i === index ? { ...m, [field]: value } : m));
    };

    const isManagerValid = (manager) => {
        return (
            manager.name.length >= 2 &&
            /^[A-Za-z ]+$/.test(manager.name) &&
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(manager.email) &&
            /^[6-9]\d{9}$/.test(manager.phoneNumber)
        );
    };

    const allManagersValid = campaignManager.length >= 2 && campaignManager.every(isManagerValid);

    const areManagersUnique =
        campaignManager[0].name.trim().toLowerCase() !== campaignManager[1].name.trim().toLowerCase() &&
        campaignManager[0].email.trim().toLowerCase() !== campaignManager[1].email.trim().toLowerCase() &&
        campaignManager[0].phoneNumber.trim() !== campaignManager[1].phoneNumber.trim();

    return (
        <>
            {!campaign ? (
                <div className="data-loading">
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress />
                    </Box>
                </div>
            ) : (
                <Box component="main" sx={{ width: "100%" }}>
                    <div className="main-content">
                        <div className="campaign-details">
                            <div className="campaign-details-head">
                                <ArrowBackIcon className="arrow-back" onClick={() => navigate(`${startPath}/${campaign.status.toLowerCase()}`)}></ArrowBackIcon>
                                <h1 className="campaign-header-name">{campaign.campaignName}</h1>
                                <div className="socialmedia-btn lite">
                                    <InstagramIcon sx={{ fontSize: 20 }} />
                                    <label>Instagram</label>
                                </div>
                            </div>
                            <div className="campaign-details-options">
                                {(campaign.status === "Live" || (campaign.status === "Completed" && !campaign.campaignClosed)) && loggedUser.role === "ADMIN" && (
                                    <>
                                        <ToggleButton
                                            value={campaign.ecApplicantViewAccess}
                                            selected={campaign.ecApplicantViewAccess}
                                            onChange={(event, newValue) => handleEcAccessToggleClick(newValue)}
                                            size="medium"
                                            sx={{
                                                minHeight: 36,
                                                px: 2.5,
                                                py: 0.75,
                                                fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                                                fontSize: '0.875rem',
                                                textTransform: 'none',
                                                backgroundColor: campaign.ecApplicantViewAccess ? '#e563a4' : '#f0f0f0',
                                                color: campaign.ecApplicantViewAccess ? '#fff' : 'inherit',
                                                '&:hover': {
                                                    backgroundColor: campaign.ecApplicantViewAccess ? '#e326a4' : '#e0e0e0',
                                                },
                                                '&.Mui-selected': {
                                                    backgroundColor: '#e563a4',
                                                    color: '#fff',
                                                    '&:hover': { backgroundColor: '#e326a4' },
                                                },
                                            }}
                                            startIcon={<CheckCircleIcon />}
                                        >
                                            {campaign.ecApplicantViewAccess ? 'Revoke EC Applicant View Access' : 'Allow EC Applicant View Access'}
                                        </ToggleButton>

                                        <Dialog
                                            fullScreen={fullScreen}
                                            open={openConfirm}
                                            onClose={handleEcAccessCancel}
                                            aria-labelledby="ec-access-dialog-title"
                                        >
                                            <DialogTitle id="ec-access-dialog-title">
                                                {!ecApplicantViewAccess ? "Grant Access?" : "Revoke Access?"}
                                            </DialogTitle>

                                            <DialogContent>
                                                {!ecApplicantViewAccess
                                                    ? "EC will be able to view all applicants for this campaign. Are you sure?"
                                                    : "EC will lose access to applicants for this campaign. Are you sure?"}
                                            </DialogContent>

                                            <DialogActions>
                                                <Button onClick={handleEcAccessCancel}>Cancel</Button>
                                                <Button onClick={handleEcAccessConfirm} autoFocus>
                                                    Confirm
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                )}
                                {(campaign.status === 'Live' || campaign.status === 'Completed') &&
                                    <>
                                        <Badge onClick={() => handleCampaignApplication()}
                                            sx={{ cursor: 'pointer' }}
                                            color="secondary" badgeContent={campaign.campaignApplicants != null && campaign.campaignApplicants.length > 0 ? campaign.campaignApplicants.filter(applicant => applicant.appliedStatus === 'Apply').length : 0} showZero>
                                            <MailIcon />
                                        </Badge>
                                    </>
                                }
                                {['Draft', 'Live', 'Pending'].includes(campaign.status) === true && loggedUser.role === 'ADMIN' && (
                                    <>
                                        <Button variant="contained" sx={{
                                            backgroundColor: '#7b5ede', '&:hover': {
                                                backgroundColor: '#5a32e4'
                                            }
                                        }} onClick={() => handleEditCampaign(campaign.status)}
                                            startIcon={<EditIcon />}>Edit</Button>
                                    </>
                                )}

                                {campaign.status === 'Pending' && loggedUser.role === 'ADMIN' && (
                                    <>
                                        <Button variant="contained" sx={{
                                            backgroundColor: '#e563a4', '&:hover': {
                                                backgroundColor: '#e326a4'
                                            }
                                        }} onClick={handleInvoiceDialogOpen}
                                            startIcon={<CheckCircleIcon />}>Accept Campaign
                                        </Button>
                                        <Dialog fullScreen={fullScreen} open={openInvoiceDialog}
                                            onClose={handleInvoiceDialogClose} aria-labelledby="responsive-dialog-title">
                                            <DialogTitle id="responsive-dialog-title">
                                                {"Please Enter Following Details"}
                                            </DialogTitle>
                                            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '12px', paddingTop: '12px !important' }}>
                                                <TextField id="outlined-basic" label={<><span>Invoice Number</span><span style={{ color: 'red' }}>*</span></>} variant="outlined" name="invoiceNumber"
                                                    value={invoiceField.invoiceNumber} onChange={(e) => handleInvoiceChange("invoiceNumber", e.target.value.replace(/\D/g, ""))}
                                                    inputProps={{ maxLength: 3 }} />
                                                <TextField id="outlined-basic" label={<><span>Payment Id</span><span style={{ color: 'red' }}>*</span></>} variant="outlined" name="paymentId"
                                                    value={invoiceField.paymentId} onChange={(e) => handleInvoiceChange("paymentId", e.target.value.replace(/[^a-zA-Z0-9]/g, ''))}
                                                    error={!/^[A-Z]{2}\d{2}[A-Z]{3}$/.test(invoiceField.paymentId) && invoiceField.paymentId !== ""}
                                                    helperText={!/^[A-Z]{2}\d{2}[A-Z]{3}$/.test(invoiceField.paymentId) && invoiceField.paymentId !== "" ? 'Incorrect Payment ID' : ''} />
                                                {campaignManager.map((manager, index) => (
                                                    <div key={index} style={{ border: '1px solid #eee', borderRadius: 8, padding: 12, marginBottom: 8 }}>
                                                        <h4>Manager {index + 1}</h4>
                                                        <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
                                                            <TextField
                                                                label={<><span>Name</span><span style={{ color: 'red' }}>*</span></>}
                                                                value={manager.name}
                                                                onChange={(e) => {
                                                                    // Only allow letters and spaces
                                                                    const value = e.target.value.replace(/[^A-Za-z ]/g, '');
                                                                    handleManagerChange(index, "name", value);
                                                                }}
                                                                error={
                                                                    (manager.name.length > 0 && manager.name.length < 2) ||
                                                                    (manager.name.length > 0 && !/^[A-Za-z ]+$/.test(manager.name))
                                                                }
                                                                helperText={
                                                                    manager.name.length > 0 && manager.name.length < 2
                                                                        ? "At least 2 characters required"
                                                                        : (manager.name.length > 0 && !/^[A-Za-z ]+$/.test(manager.name)
                                                                            ? "Only letters and spaces allowed"
                                                                            : "")
                                                                }
                                                                sx={{ flex: 1 }}
                                                            />
                                                            <TextField
                                                                label={<><span>Email</span><span style={{ color: 'red' }}>*</span></>}
                                                                value={manager.email}
                                                                onChange={(e) => handleManagerChange(index, "email", e.target.value)}
                                                                error={manager.email !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(manager.email)}
                                                                helperText={manager.email !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(manager.email) ? "Invalid email" : ""}
                                                                sx={{ flex: 1 }}
                                                            />
                                                        </Box>
                                                        <TextField
                                                            label={<><span>Phone Number</span><span style={{ color: 'red' }}>*</span></>}
                                                            value={manager.phoneNumber}
                                                            onChange={(e) => handleManagerChange(index, "phoneNumber", e.target.value.replace(/\D/g, ""))}
                                                            inputProps={{ maxLength: 10 }}
                                                            error={manager.phoneNumber !== "" && !/^[6-9]\d{9}$/.test(manager.phoneNumber)}
                                                            helperText={manager.phoneNumber !== "" && !/^[6-9]\d{9}$/.test(manager.phoneNumber) ? "Enter valid 10 digit Indian number starting with 6,7,8,9" : ""}
                                                            sx={{ width: '100%', whiteSpace: 'pre-line' }}
                                                        />
                                                    </div>
                                                ))}
                                                {!areManagersUnique && (
                                                    <Box sx={{ color: 'red', mb: 1 }}>
                                                        Manager Name, Email, and Phone Number must be unique.
                                                    </Box>
                                                )}
                                            </DialogContent>
                                            <DialogActions>
                                                <Button autoFocus onClick={handleInvoiceDialogClose}>
                                                    Cancel
                                                </Button>
                                                <Button
                                                    disabled={
                                                        invoiceField.invoiceNumber === "" ||
                                                        invoiceField.paymentId === "" ||
                                                        !/^[A-Z]{2}\d{2}[A-Z]{3}$/.test(invoiceField.paymentId) ||
                                                        invoiceField.invoiceNumber.length < 3 ||
                                                        !allManagersValid ||
                                                        !areManagersUnique
                                                    }
                                                    onClick={() => updateCampaignsStatus((campaign && campaign.campaignId), campaignManager, setAlertOpen, setAlertMessage, setAlertSeverity, navigate)}
                                                    autoFocus
                                                >
                                                    Save
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                )}
                                {(campaign.status === 'Live' || campaign.status === 'Pending' || campaign.status === 'Draft') && loggedUser.role === 'ADMIN' && (
                                    <>
                                        <Button variant="contained" color="error"
                                            onClick={() => openDialogForCloseCampaign()}
                                            startIcon={<HighlightOffIcon />}>{campaign.status === 'Draft' ? 'Discard Campaign' :
                                                campaign.status === 'Pending' ? 'Cancel Campaign' : 'Close Campaign'}
                                        </Button>
                                        <Dialog
                                            open={openClosedCampaign}
                                            onClose={openDialogForCloseCampaign}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">
                                                {"Warning"}
                                            </DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    Are you sure want to {campaign.status === 'Draft' ? 'discard campaign' :
                                                        campaign.status === 'Pending' ? 'cancel campaign' : 'close campaign'}?
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={openDialogForCloseCampaign}>Cancel</Button>
                                                <Button onClick={(e) => { closedCampaignAction(e); }} autoFocus>
                                                    {campaign.status === 'Draft' ? 'Discard Campaign' :
                                                        campaign.status === 'Pending' ? 'Cancel Campaign' : 'Close Campaign'}
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                )}
                                {/* {campaign.status === 'Completed' && loggedUser.role === 'ADMIN' &&
                                                    <>

                                                        {campaign.invoiceStatus === 'Draft' ? (
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    backgroundColor: '#7b5ede',
                                                                    '&:hover': {
                                                                        backgroundColor: '#5a32e4',
                                                                    },
                                                                }}
                                                                onClick={() => handleRaiseInvoice(campaign.status)}
                                                            >
                                                                Complete invoice
                                                            </Button>
                                                        ) : campaign.invoiceStatus === 'Completed' || campaign.invoiceStatus === 'Pending' ? (
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    backgroundColor: '#7b5ede',
                                                                    '&:hover': {
                                                                        backgroundColor: '#5a32e4',
                                                                    },
                                                                }}
                                                                onClick={() => handleRaiseInvoice(campaign.invoiceId)}
                                                            >
                                                                View invoice
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    backgroundColor: '#7b5ede',
                                                                    '&:hover': {
                                                                        backgroundColor: '#5a32e4',
                                                                    },
                                                                }}
                                                                onClick={() => handleRaiseInvoice(campaign.status)}
                                                            >
                                                                Raise invoice
                                                            </Button>
                                                        )}

                                                    </>
                                                } */}

                            </div>
                            <div className="campaign-list-hr"></div>
                            <div className="campaign-overview">
                                <div className="campaign-overview-header">
                                    <h1>Campaign Overview</h1>
                                </div>
                                <div className="campaign-data">
                                    <div>Channel: <span>Instagram</span></div>
                                    {campaign.status === 'Draft' || campaign.status === 'Pending'
                                        ? <div className="option-row">
                                            <div>Campaign created: <span>{moment(campaign.creationDate).format("ll")}</span></div>
                                            {campaign.status === 'Pending' && <div>Last date of application: <span>{moment(campaign.lastDateOfApplication).format("ll")}</span></div>}
                                        </div>
                                        : <div className="option-row">
                                            <div>Campaign approved: <span>{moment(campaign.approvedDate).format("ll")}</span></div>
                                            <div>Last date of application: <span>{moment(campaign.lastDateOfApplication).format("ll")}</span></div>
                                        </div>
                                    }
                                    {pathname.includes('/all-campaigns') && loggedUser.role === 'ADMIN' && (
                                        <div>Created By: <span>{campaign.createdBy === null ? "Unknown" : campaign.createdBy.fullName}</span></div>
                                    )}
                                    {pathname.includes('/all-campaigns') && loggedUser.role === 'ADMIN' && (
                                        <div>Campaign Owner: <span>{campaign.campaignOwner.companyName}</span></div>
                                    )}
                                    {pathname.includes('/all-campaigns') && loggedUser.role === 'ADMIN' && (
                                        <div>Brand: <span>{campaign.brand != null ? campaign.brand.name : null}</span></div>
                                    )}
                                    <div style={{ margin: "24px 0 8px 0", fontWeight: 600 }}>Campaign Managers:</div>
                                    <Box sx={{ width: '100%', marginBottom: '24px' }}>
                                        {(campaign.campaignManager && campaign.campaignManager.length > 0)
                                            ? campaign.campaignManager.map((manager, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        alignItems: 'center',
                                                        padding: '8px 0',
                                                        borderBottom: index !== campaign.campaignManager.length - 1 ? '1px solid #eee' : 'none',
                                                        gap: 3,
                                                    }}
                                                >
                                                    <Box sx={{ minWidth: 120, fontWeight: 500, color: '#65308F' }}>
                                                        {manager?.name ? manager.name : "N/A"}
                                                    </Box>
                                                    <Box sx={{ minWidth: 220 }}>
                                                        {manager?.email
                                                            ? <a href={`mailto:${manager.email}`} style={{ color: '#65308F', textDecoration: 'underline', wordBreak: 'break-all' }}>{manager.email}</a>
                                                            : <span style={{ color: '#999' }}>N/A</span>
                                                        }
                                                    </Box>
                                                    <Box sx={{ minWidth: 120 }}>
                                                        {manager?.phoneNumber
                                                            ? <a href={`tel:${manager.phoneNumber}`} style={{ color: '#65308F', textDecoration: 'underline' }}>{manager.phoneNumber}</a>
                                                            : <span style={{ color: '#999' }}>N/A</span>
                                                        }
                                                    </Box>
                                                </Box>
                                            ))
                                            : <Box sx={{ color: '#999', padding: '8px 0' }}>No managers assigned.</Box>
                                        }
                                    </Box>
                                    <div className="description-outer-container" style={{ marginBottom: '20px' }}>
                                        <div className="adjust-alignment campaign-brief">Brief:</div>
                                        <div>
                                            <div className="description-content" dangerouslySetInnerHTML={{ __html: campaign.description }} />
                                        </div>
                                    </div>
                                    <div>Project Type: <span>{campaign.projectType?.projectType || "N/A"}</span></div>
                                    <div>Shoot Location Type: <span>{campaign.shootLocationType?.shootLocationType || "N/A"}</span></div>
                                    <div>Languages: <span>{campaign.languages?.length ? campaign.languages.map(lang => lang.language).join(", ") : "N/A"}</span></div>
                                    <div>Gender: <span>{campaign.gender?.length ? campaign.gender.join(", ") : "N/A"}</span></div>
                                    <div>Age Range: <span>{campaign.ageRange?.length ? campaign.ageRange.map(ar => ar.ageRange).join(", ") : "N/A"}</span></div>
                                    <div>Target Types: <span>
                                        {campaign.categoryTypes && campaign.categoryTypes.some(item => item !== '') ? campaign.categoryTypes.join(', ') : ''}
                                        {campaign.categoryTypes && campaign.categoryTypes.some(item => item !== '') && campaign.customCategory && campaign.customCategory.some(item => item !== '') ? ', ' : ''}
                                        {campaign.customCategory && campaign.customCategory.some(item => item !== '') ? campaign.customCategory.filter(item => item !== '').map(item => item.replace(/"/g, '')).join(', ') : ''}
                                        {!(campaign.categoryTypes && campaign.categoryTypes.some(item => item !== '')) && !(campaign.customCategory && campaign.customCategory.some(item => item !== '')) ? "N/A" : ""}
                                    </span></div>
                                    <div>Campaign Category Type: <span>{campaign.campaignCategoryType?.campaignCategoryType || "N/A"}</span></div>
                                    <div>Location: <span>{campaign.campaignLocations?.length ? campaign.campaignLocations.map(cityState => `${cityState}`).join(', ') : "N/A"}</span></div>
                                    <div>Number of creators: <span>{campaign.creators ?? "N/A"}</span></div>
                                </div>

                            </div>
                            <div className="alert-msg">
                                <CustomAlert open={alertOpen} severity={alertSeverity} message={alertMessage} onClose={() => setAlertOpen(false)} />
                            </div>
                        </div>
                    </div>
                </Box>
            )}
            <DialogBox userDetails={loggedUser} openAlert={openInstaHandleAlert} setOpenAlert={setOpenInstaHandleAlert} campaignId={campaignid} />
            <Dialog
                open={openWithdrawConfirmationDialog}
                onClose={() => setOpenWithdrawConfirmationDialog(false)}
                aria-labelledby="withdraw-confirmation-dialog-title"
                aria-describedby="withdraw-confirmation-dialog-description"
            >
                <DialogTitle id="withdraw-confirmation-dialog-title" sx={{ color: '#e326a4' }}>Withdraw Application</DialogTitle>
                <DialogContent>
                    <DialogContentText id="withdraw-confirmation-dialog-description" sx={{ color: '#000000' }}>
                        Do you really want to withdraw your application?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenWithdrawConfirmationDialog(false)}>No</Button>
                    <Button onClick={(e) => {
                        handleApplyCampaign(e, campaign.campaignId, loggedUser.isInstaAccountPrivate, setApply, setOpenInstaHandleAlert, setAlertOpen, setAlertMessage, setAlertSeverity);
                        setOpenWithdrawConfirmationDialog(false);
                    }}>Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default CampaignDetails;
